import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'
import { Grid, Typography, makeStyles } from '@material-ui/core'
import { FormikInputField } from 'components/form/InputField'
import { FormikDropdownField } from 'components/form/Dropdown'
import { FormikTextareaField } from 'components/form/TextareaField'
import { adminRelianceLevel, adminTransportCapacity } from 'admin/actions/admin_dropdown_options'

const useStyles = makeStyles((theme) => ({
  fieldDescription: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: -4,
    marginBottom: 4
  }
}))

// Resourcing & capacity fields for beneficiary vetting. - same structure as BeneficiaryVettingNpoDssFields: label, description, then input.
export default function BeneficiaryVettingResourcingCapacityFields({ formik_props, fieldsDisabled = false }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const company = get(formik_props.values, 'company', {})
  

  const relianceOptions = useSelector(() => adminRelianceLevel.getAsOptions())
  const transportCapacityOptions = useSelector(() => adminTransportCapacity.getAsOptions())

  useEffect(() => {
    dispatch(adminRelianceLevel.fetchListIfNeeded())
    dispatch(adminTransportCapacity.fetchListIfNeeded())
  }, [dispatch])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormikInputField
          name="company.full_time_females"
          type="number"
          label="Full-Time Females"
          value={get(company, 'full_time_females')}
          formik_props={formik_props}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Enter the total number of full-time female staff. Confirm against payroll or HR data if available.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikInputField
          name="company.full_time_males"
          type="number"
          label="Full-Time Males"
          value={get(company, 'full_time_males')}
          formik_props={formik_props}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Enter the total number of full-time male staff. Confirm against payroll or HR data if available.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikInputField
          name="company.number_of_volunteers"
          type="number"
          label="Number of Volunteers"
          value={get(company, 'number_of_volunteers')}
          formik_props={formik_props}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Capture the number of active volunteers. Clarify if this includes ad hoc helpers.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikDropdownField
          name="company.reliance_on_sa_harvest"
          label="Reliance on SA Harvest"
          options={relianceOptions || []}
          formik_props={formik_props}
          placeholder="Select..."
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Select the CBO's level of reliance from the dropdown.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikDropdownField
          name="company.transport_capacity"
          label="Transport Capacity"
          options={transportCapacityOptions || []}
          formik_props={formik_props}
          placeholder="Select..."
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Select from the dropdown based on the CBO's ability to collect food.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikTextareaField
          name="company.proposal_writing_capabilities"
          label="Proposal Writing Capabilities"
          formik_props={formik_props}
          value={get(company, 'proposal_writing_capabilities')}
          rows={4}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Comment on the organisation's ability to write and submit funding proposals.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikTextareaField
          name="company.digital_capabilities"
          label="Digital Capabilities"
          formik_props={formik_props}
          value={get(company, 'digital_capabilities')}
          rows={4}
          disabled={fieldsDisabled}
        />
        <Typography className={classes.fieldDescription} variant="caption" display="block">
          Comment on the organisation's use of technology for communication, reporting, or operations.
        </Typography>
      </Grid>
    </Grid>
  )
}
